// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimHistory = t.struct({
    accountName: t.maybe(t.String),
    accountNumber: t.maybe(t.String),
    claimNumber: t.maybe(t.String),
    claimStatusDescription: t.maybe(t.String),
    claimType: t.maybe(t.String),
    claimTypeDescription: t.maybe(t.String),
    creditMemoDate: t.maybe(t.Number),
    creditMemoNumber: t.maybe(t.String),
    failureDate: t.maybe(t.Number),
    failurePart: t.maybe(t.String),
    isSubmittingDealer: t.maybe(t.Bool),
    pin: t.maybe(t.String),
    programDescription: t.maybe(t.String),
    programName: t.maybe(t.String),
    reference1: t.maybe(t.String),
    reference2: t.maybe(t.String),
    repairDate: t.maybe(t.Number),
    subClaimType: t.maybe(t.String),
    subClaimTypeDescription: t.maybe(t.String),
    submissionDate: t.maybe(t.Number)
}, {
    name: 'ClaimHistory',
    strict: true
});

export const getDefaultState = () => new ClaimHistory({});

export default ClaimHistory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-history.js